
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lan]/active/[pageId]/[name]",
      function () {
        return require("private-next-pages/[lan]/active/[pageId]/[name].tsx");
      }
    ]);
  